export const DELIVERY_LIST_COLUMNS = [
  { field: 'nomeUnidade', headerName: 'Unidade', align: 'left', sort: 'asc' },
  {
    field: 'nomeColaborador',
    headerName: 'Colaborador',
    align: 'left',
    sort: 'asc'
  },
  { field: 'cpf', headerName: 'CPF', align: 'left', sort: 'asc' },
  {
    field: 'numeroCartao',
    headerName: 'Nº do cartão',
    align: 'center',
    sort: 'asc'
  },
  {
    field: 'nomeOperadora',
    headerName: 'Operadora',
    align: 'left',
    sort: 'asc'
  },
  { field: 'acoes', headerName: '', align: 'center' }
]
